import Repository from './repository';
const resource = '/archiver';

export default {
	getArchiveRequests(payload) {
		return Repository.postWithAuth(`${resource}/requests`, payload);
	},
	getArchiveSnapshots() {
		return Repository.postWithAuth(`${resource}/take-snapshot`, {});
	},
	downloadArchiveRequest(id) {
		return Repository.getWithAuth(`${resource}/download/${id}`);
	},
	getRemovalRequests() {
		return Repository.getWithAuth(`${resource}/removal-requests`);
	},
	archiveAndDelete(payload) {
		return Repository.postWithAuth(`${resource}/archive-and-delete`, payload);
	},
	retryArchiveRequest(id) {
		return Repository.postWithAuth(`${resource}/requests/${id}/retry`, {});
	},
};
